<template>
  <div class="page" :style="{'padding':isMobile?'0':'0 10%'}">
    <!-- 点击跳转历史 -->
    <div class="historyBox" @click="clickhistory">
      <img
        src="https://kjsx.oss-cn-hangzhou.aliyuncs.com/shadow_game/2026-09-21/1789991128958.png"
        alt
      />
    </div>
    <div :class="isMobile?'modelBox':''">
      <!-- -------------------头部区域----------------- -->
      <div class="topImg">
        <template v-if="detail.content_top.type == 1">
          <img :src="detail.content_top.url" />
        </template>
        <template v-else-if="detail.content_top.type == 2">
          <div v-html="detail.content_top.content"></div>
        </template>
        <template v-else>
          <div class="topWz">{{ detail.content_top.content }}</div>
        </template>
        <!-- <template>
        <div style="position: relative;">
          <img src="https://kjsx.oss-cn-hangzhou.aliyuncs.com/shadow_game_photo/2025-09-16/1757993680015.jpg" />
          <video style="position: absolute;bottom: 4%;left: 14%;width: 72%;height: 29%;" src="https://api.istv.cn/hote.mp4" controls autoplay muted></video>
  </div>
        </template>-->
      </div>
      <!-- ------------------中间区域------------------ -->

      <div class="channelBox">
        <img
          class="channelImg"
          src="https://kjsx.oss-cn-hangzhou.aliyuncs.com/shadow_game/2026-10-27/1793092572692.png"
        />
        <!-- 视觉赛道 -->
        <div
          :class="showRegistration && detailTwo[1] ? '' : 'hideBtn'"
          class="visionBtn"
          @click="detailTwo[1] && goSubmit(detailTwo[1].id)"
        ></div>
        <div v-if="detailTwo[1]" class="moreBtn1" @click="goMore(detailTwo[1])">
          <img
            class="channelImg"
            src="https://kjsx.oss-cn-hangzhou.aliyuncs.com/shadow_game_photo/2025-10-10/1760060835328.png"
          />
        </div>
        <div class="visionSwip">
          <div class="cententForChilImgBox">
            <el-carousel
              v-if="detailTwo&&detailTwo[1]&&detailTwo[1].newalbums&&detailTwo[1].newalbums.length>0&&showRegistration"
              arrow="always"
              trigger="click"
              :style="{'aspect-ratio':isMobile?'1/0.39':'1/0.38'}"
            >
              <el-carousel-item
                v-for="(itemaa, indexaa) in detailTwo[1].newalbums"
                :key="indexaa + 'carousel'"
              >
                <div class="swipbox" style="aspect-ratio: 1 / 0.3;">
                  <div class="swipitem" v-for="swipitem in itemaa" :key="swipitem.cover">
                    <img @click="goDetail(swipitem)" :src="swipitem.cover" />
                    <div class="dz" style="display: flex;">
                      <i
                        v-if="swipitem.photo_number > 1"
                        style="display: flex;align-items: center;margin-right: 5px;"
                        class="el-icon-document-copy"
                      ></i>
                      <div class="dzTil">
                        {{ swipitem.title
                        }}{{ swipitem.name ? `(${swipitem.name})` : "" }}
                      </div>
                      <!-- <div style="display: flex;" @click.stop="goLike(swipitem)">
                        <div class="dzImg">
                          <img
                            style="cursor: pointer;"
                            v-if="swipitem.is_like"
                            src="@/assets/ydz.png"
                          /> 
                          <img style="cursor: pointer;" v-else src="@/assets/wdz1.png" />
                        </div>
                        <div class="dzNumber">{{ swipitem.like_num || 0 }}</div>
                      </div> -->
                      <!-- <div
                        style="display: flex;margin-left:10px;"
                        @click.stop="goVote(swipitem)"
                        v-if="detail.is_open_vote == 1"
                      >
                        <div class="dzImg">
                          <img
                            style="cursor: pointer;"
                            v-if="swipitem.is_vote"
                            src="@/assets/ytp.png"
                          />

                          <img style="cursor: pointer;" v-else src="@/assets/wtp1.png" />
                        </div>
                        <div class="dzNumber">{{ swipitem.vote_num || 0 }}</div>
                      </div> -->
                    </div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>

            <!-- 没有作品 -->

            <el-carousel
              v-else
              arrow="always"
              trigger="click"
              :style="{'aspect-ratio':isMobile?'1/0.39':'1/0.38'}"
            >
              <el-carousel-item
                v-for="(holeData1,holeindex) in holeList"
                :key="holeindex + 'carousel1'"
              >
                <div class="swipbox" style="aspect-ratio: 1 / 0.3;">
                  <div
                    class="swipitem"
                    v-for="(holeData2,holeindex2) in holeData1"
                    :key="holeindex2+'carousel2'"
                  >
                    <img :src="holeData2.myimg" />
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>

        <!-- 工艺赛道 -->
        <div
          :class="showRegistration && detailTwo[0] ? '' : 'hideBtn'"
          class="workmanshipBtn"
          @click="detailTwo[0] && goSubmit(detailTwo[0].id)"
        ></div>
        <div v-if="detailTwo[0]" class="moreBtn2" @click="goMore(detailTwo[0])">
          <img
            class="channelImg"
            src="https://kjsx.oss-cn-hangzhou.aliyuncs.com/shadow_game_photo/2025-10-10/1760060835328.png"
          />
        </div>
        <div class="visionSwip" style="top:72%">
          <div class="cententForChilImgBox">
            <el-carousel
              v-if="detailTwo&&detailTwo[0]&&detailTwo[0].newalbums&&detailTwo[0].newalbums.length>0&&showRegistration"
              arrow="always"
              trigger="click"
              :style="{'aspect-ratio':isMobile?'1/0.39':'1/0.38'}"
            >
              <el-carousel-item
                v-for="(itemaa, indexaa) in detailTwo[0].newalbums"
                :key="indexaa + 'carousel'"
              >
                <div class="swipbox" style="aspect-ratio: 1 / 0.3;">
                  <div class="swipitem" v-for="swipitem in itemaa" :key="swipitem.cover">
                    <img @click="goDetail(swipitem)" :src="swipitem.cover" />
                    <div class="dz" style="display: flex;">
                      <i
                        v-if="swipitem.photo_number > 1"
                        style="display: flex;align-items: center;margin-right: 5px;"
                        class="el-icon-document-copy"
                      ></i>
                      <div class="dzTil">
                        {{ swipitem.title
                        }}{{ swipitem.name ? `(${swipitem.name})` : "" }}
                      </div>
                      <!-- <div style="display: flex;" @click.stop="goLike(swipitem)">
                        <div class="dzImg">
                          <img
                            style="cursor: pointer;"
                            v-if="swipitem.is_like"
                            src="@/assets/ydz.png"
                          />
                          <img style="cursor: pointer;" v-else src="@/assets/wdz1.png" />
                        </div>
                        <div class="dzNumber">{{ swipitem.like_num || 0 }}</div>
                      </div> -->
                      <!-- <div
                        style="display: flex;margin-left:10px;"
                        @click.stop="goVote(swipitem)"
                        v-if="detail.is_open_vote == 1"
                      >
                        <div class="dzImg">
                          <img
                            style="cursor: pointer;"
                            v-if="swipitem.is_vote"
                            src="@/assets/ytp.png"
                          />

                          <img style="cursor: pointer;" v-else src="@/assets/wtp1.png" />
                        </div>
                        <div class="dzNumber">{{ swipitem.vote_num || 0 }}</div>
                      </div> -->
                    </div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>

            <!-- 没有作品 -->
            <el-carousel
              v-else
              arrow="always"
              trigger="click"
              :style="{'aspect-ratio':isMobile?'1/0.39':'1/0.38'}"
            >
              <el-carousel-item
                v-for="(holeData1,holeindex) in holeList"
                :key="holeindex + 'carousel1'"
              >
                <div class="swipbox" style="aspect-ratio: 1 / 0.3;">
                  <div
                    class="swipitem"
                    v-for="(holeData2,holeindex2) in holeData1"
                    :key="holeindex2+'carousel2'"
                  >
                    <img :src="holeData2.myimg" />
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>

      <div class="topImg wincss">
        <template v-if="detail.event_overview.type == 1">
          <img :src="detail.event_overview.url" />
        </template>
        <template v-else-if="detail.event_overview.type == 2">
          <div class="winbox winbox1">
            <div @click="goDetail({id:2791})"></div>
            <div @click="goDetail({id:2819})"></div>
            <div @click="goDetail({id:2762})"></div>
          </div>
          <div class="winbox winbox2">
            <div @click="goDetail({id:2800})"></div>
            <div @click="goDetail({id:3028})"></div>
            <div @click="goDetail({id:2781})"></div>
          </div>
          <!-- <div class="winbox winbox3">
            <div @click="goDetail({id:1586})"></div>
            <div @click="goDetail({id:1585})"></div>
            <div @click="goDetail({id:1797})"></div>
          </div>
          <div class="winbox winbox4">
            <div @click="goDetail({id:1793})"></div>
            <div @click="goDetail({id:1688})"></div>
            <div @click="goDetail({id:1684})"></div>
          </div>
          <div class="winbox winbox5">
            <div @click="goDetail({id:2065})"></div>
            <div @click="goDetail({id:2074})"></div>
            <div @click="goDetail({id:2092})"></div>
          </div>
          <div class="winbox winbox6">
            <div @click="goDetail({id:2090})"></div>
            <div @click="goDetail({id:2012})"></div>
            <div @click="goDetail({id:2015})"></div>
          </div>
          <div class="winbox winbox7">
            <div @click="goDetail({id:2281})"></div>
            <div @click="goDetail({id:2361})"></div>
            <div @click="goDetail({id:2349})"></div>
          </div>
          <div class="winbox winbox8">
            <div @click="goDetail({id:2135})"></div>
            <div @click="goDetail({id:2137})"></div>
            <div @click="goDetail({id:2105})"></div>
          </div> -->
          <div v-html="detail.event_overview.content"></div>
        </template>
        <template v-else>
          <div class="topWz">{{ detail.event_overview.content }}</div>
        </template>
      </div>

      <!-- <div
      class="topImg"
    >
      <template v-if="detail.content_bottom.type == 1">
        <img :src="detail.content_bottom.url" />
      </template>
      <template v-else-if="detail.content_bottom.type == 2">
        <div v-html="detail.content_bottom.content" style></div>
      </template>
      <template v-else>
        <div class="topWz">{{ detail.content_bottom.content }}</div>
      </template>
      </div>-->
    </div>
  </div>
</template>

<script>
import {
  getShadowGameDetailAPI,
  shadow_game_type_api,
  shadow_game_album_dz_api,
  shadow_game_album_vote_api
} from "@/api/index.js";
import { getShadowGameRoute } from "@/utils/shadowGameRoute";
export default {
  components: {},
  name: "IndexCurrent",
  data() {
    return {
      id: "",
      publicId: "",
      detail: {
        content_top: {},
        event_overview: {},
        content_bottom: {}
      },
      detailTwo: [],
      is_excellent: 0,
      hjzpList: [],
      yxzp: {},
      holeList: []
    };
  },
  mounted() {
    console.log("-------------这个页面");
    const gameRoute = getShadowGameRoute(this.$route.query.id);
    this.publicId = gameRoute.publicId;
    this.id = gameRoute.gameId;
    this.getDetail();
    this.getDetailType();
    this.getholeList();
  },
  computed: {
    showRegistration() {
      const rawEndDate = this.detail && this.detail.end_date
        ? String(this.detail.end_date).trim()
        : "";

      // 详情接口返回前，end_date 为空属于正常情况，直接不显示报名按钮。
      if (!rawEndDate) {
        return false;
      }

      // 兼容 "YYYY-MM-DD" 和 "YYYY-MM-DD HH:mm:ss" 这类返回值。
      const matchedDate = rawEndDate.match(/^(\d{4}-\d{2}-\d{2})/);
      if (!matchedDate) {
        console.error("结束日期格式错误:", rawEndDate);
        return false;
      }

      // 修复 iOS / 部分浏览器对 "-" 分隔符兼容问题。
      const endTimeStamp = new Date(
        matchedDate[1].replace(/-/g, "/")
      ).setHours(0, 0, 0, 0);

      if (Number.isNaN(endTimeStamp)) {
        console.error("结束日期解析失败:", rawEndDate);
        return false;
      }

      // 3. 获取当前时间的「当天0点0分0秒」的时间戳
      const now = new Date();
      const currentTimeStamp = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate()
      ).getTime();

      // 4. 比较时间戳：结束日期 ≤ 当前日期 → 返回true
      return endTimeStamp >= currentTimeStamp;
    }
  },
  methods: {
    // 2024回顾
    clickhistory() {
      window.open("/history");
    },
    getholeList() {
      // for (let index = 1; index < 35; index += 2) {
      //   if (index != 35) {
      //     this.holeList.push([
      //       { myimg: require(`@/assets/testimg/${index}.jpg`) },
      //       { myimg: require(`@/assets/testimg/${index + 1}.jpg`) }
      //     ]);
      //   } else {
      //     this.holeList.push([
      //       { myimg: require(`@/assets/testimg/${index}.jpg`) }
      //     ]);
      //   }
      // }
    },
    getDetail() {
      let data = {
        id: this.id
      };
      getShadowGameDetailAPI(data)
        .then(res => {
          console.log("---------详情", res);
          this.detail = res.data;
          document.title = this.detail.title;
          if (this.detail.content_top.type) {
            this.detail.content_top.content = this.removePreAndCodeTags(
              this.detail.content_top.content
            );
            this.detail.content_top.content = this.replaceAngleBrackets(
              this.detail.content_top.content
            );
            let regex = new RegExp("<img", "gi");
            this.detail.content_top.content = this.detail.content_top.content.replace(
              regex,
              `<img style="width: 100%;display: block;margin: 0;padding: 0;object-fit: cover;"`
            );
          }
          if (this.detail.event_overview.type) {
            this.detail.event_overview.content = this.removePreAndCodeTags(
              this.detail.event_overview.content
            );
            this.detail.event_overview.content = this.replaceAngleBrackets(
              this.detail.event_overview.content
            );
            let regex = new RegExp("<img", "gi");
            this.detail.event_overview.content = this.detail.event_overview.content.replace(
              regex,
              `<img style="width: 100%;display: block;margin: 0;padding: 0;object-fit: cover;"`
            );
          }
          if (this.detail.content_bottom.type) {
            this.detail.content_bottom.content = this.removePreAndCodeTags(
              this.detail.content_bottom.content
            );
            this.detail.content_bottom.content = this.replaceAngleBrackets(
              this.detail.content_bottom.content
            );
            let regex = new RegExp("<img", "gi");
            this.detail.content_bottom.content = this.detail.content_bottom.content.replace(
              regex,
              `<img style="width: 100%;display: block;margin: 0;padding: 0;object-fit: cover;"`
            );
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getDetailType() {
      let t = this;
      let data = {
        shadow_game_id: this.id
      };
      const loading = this.$loading({
        lock: true
      });
      this.detailTwo = [];
      shadow_game_type_api(data)
        .then(res => {
          console.log("-------------------数据", res);
          let list = res.data.children;
          if (!res.data.children || res.data.children.length == 0) {
            this.detailTwo = [];
            return;
          }
          let listZhong = [];
          let yxzpTitle = "";
          let hjzpList = [];
          let indexXb = [];
          let is_excellent = 0;
          list.map((item, index) => {
            item.children.map((itema, indexa) => {
              if (itema.is_excellent) {
                yxzpTitle = itema;
                is_excellent = 1;
                hjzpList = itema.albums;
                indexXb = [index, indexa];
              } else {
                let halfLength = Math.ceil(itema.albums.length / 2);
                itema.albums1 = itema.albums.slice(0, halfLength);
                itema.albums2 = itema.albums.slice(halfLength);
                console.log("------------数据", itema.albums, itema.albums1);
                // 重新定义照片数据

                let result = [];
                for (let i = 0; i < itema.albums.length; i += 2) {
                  let pusharr = itema.albums.slice(i, i + 2);
                  result.push(pusharr);
                }
                if (result.length > 10) {
                  result = result.slice(0, 10);
                }

                itema.newalbums = result;

                listZhong.push(itema);
              }
            });
          });

          this.$nextTick(function() {
            this.is_excellent = is_excellent;
            if (hjzpList.length > 0) {
              let name = ".swiper-canpinHjzp";
              const mySwiperTwo = new t.$swiper(name, {
                // 方向
                direction: "horizontal",
                slidesPerView: "auto", // 每屏显示3个滑块
                slidesPerGroup: 1, // 每次滑动3个滑块
                spaceBetween: 10,
                freeMode: true,
                observer: true,
                // 自动播放
                autoplay: false
              });
            }

            this.yxzp = yxzpTitle;
            this.hjzpList = hjzpList;
            this.detailTwo = listZhong;
            console.log("-----------------listZhong", listZhong);
            setTimeout(function() {
              let lista = listZhong;
              lista.map((itema, indexa) => {
                let name = ".swiper-canpin" + indexa;
                const mySwiperTwo = new t.$swiper(name, {
                  // 方向
                  direction: "horizontal",
                  slidesPerView: "auto", // 每屏显示3个滑块
                  slidesPerGroup: 1, // 每次滑动3个滑块
                  spaceBetween: 10,
                  freeMode: true,
                  observer: true,
                  // 自动播放
                  autoplay: false
                });
                console.log("mySwiperTwo", mySwiperTwo);
              });
            }, 100);
          });
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          loading.close();
        });
    },
    removePreAndCodeTags(htmlString) {
      const regex = /<pre[^>]*>|<code[^>]*>|<\/pre>|<\/code>/gi;
      return htmlString.replace(regex, "");
    },
    replaceAngleBrackets(str) {
      return str.replace(/&lt;/g, "<").replace(/&gt;/g, ">");
    },
    goLike(e) {
      let data = {
        shadow_game_album_id: e.id
      };
      const loading = this.$loading({
        lock: true
      });
      shadow_game_album_dz_api(data)
        .then(res => {
          console.log(res);
          e.is_like = !e.is_like;
          if (e.is_like) {
            e.like_num++;
          } else {
            e.like_num--;
          }
          this.$message.success(res.msg);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          loading.close();
        });
    },
    goVote(e) {
      console.log("------------投票");
      let data = {
        shadow_game_album_id: e.id
      };
      const loading = this.$loading({
        lock: true
      });
      shadow_game_album_vote_api(data)
        .then(res => {
          if (res.code == 200) {
            e.is_vote = true;
            e.vote_num++;
          }

          // if (e.is_vote) {
          //   e.vote_num++;
          // } else {
          //   e.vote_num--;
          // }
          this.$message.success(res.msg);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          loading.close();
        });
    },
    goMore(e) {

      if (!this.showRegistration) {
        this.$notify.error({
          title: "提示",
          message: "活动时间已截止"
        });
        return
      }
      this.$router.push({ path: "/list", query: { id: this.publicId, pid: e.id, typeId: e.pid } });
    },
    goDetail(e) {
      this.$router.push(`/detail?id=${e.id}`);
    },
    goSubmit(e) {
      this.$router.push({ path: "/submit", query: { id: this.publicId, typeId: e } });
    }
  }
};
</script>

<style></style>
<style scoped lang="scss">
.page {
  width: 100%;
  overflow: hidden;
  box-sizing: border-box;
  background-image: url("https://kjsx.oss-cn-hangzhou.aliyuncs.com/shadow_game_photo/2025-09-16/1758031653469.jpg");
  background-size: 100%;
}

.wincss {
  position: relative;
  .winbox {
    position: absolute;
    display: flex;
    left: 20%;
    width: 57%;
    height: 3.5%;
    div {
      flex: 1;
      cursor: pointer;
    }
  }
  .winbox1 {
    bottom: 67.6%;
  }
  .winbox2 {
    bottom: 63.2%;
  }
  .winbox3 {
    bottom: 67.6%;
  }
  .winbox4 {
    bottom: 63.8%;
  }
  .winbox5 {
    bottom: 58.7%;
  }
  .winbox6 {
    bottom: 54.9%;
  }
  .winbox7 {
    bottom: 49.4%;
  }
  .winbox8 {
    bottom: 45.8%;
  }
}

.modelBox {
  width: 120%;
  transform: translateX(-7%);
}

.historyBox {
  position: fixed;
  cursor: pointer;
  right: 3%;
  bottom: 3%;
  width: 12%;
  z-index: 999;
  img {
    width: 100%;
  }
}

.el-row {
  max-width: 100%;
  box-sizing: border-box;
  margin-left: 0 !important;
  margin-right: 0 !important;

  &:last-child {
    margin-bottom: 0;
  }
}

.topImg {
  width: 100%;
  position: relative;

  img {
    width: 100%;
    display: block;
    margin: 0;
    padding: 0;
  }

  .topDw {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    color: #fff;
    font-weight: 500;
  }

  .topWz {
    font-size: 18px;
    font-weight: 500;
    text-align: center;
    margin: 20px 0;
  }
}

.centent {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  box-sizing: border-box;

  .cententFor {
    margin-top: 20px;

    .cententForTitle {
      font-size: 18px;
      font-weight: 500;
      // text-align: center;
      margin-bottom: 10px;
    }

    .cententForChil {
      .cententForChilTop {
        display: flex;
        justify-content: space-between;
        // align-items: center;
        margin-bottom: 10px;
        padding-bottom: 10px;

        .cententForChilTopOne {
          font-size: 24px;
          font-weight: 500;
        }

        .cententForChilTopTwo {
          font-size: 14px;
          color: rgb(29, 151, 254);

          font-weight: 600;
          & img:nth-child(1) {
            width: 25%;
            cursor: pointer;
          }
          & img:nth-child(2) {
            width: 100%;
          }
        }

        .cententForChilTopImg {
          flex: 1;
          display: flex;
          justify-content: end;
          margin-left: 10px;

          img {
            width: 300px;
            height: 30px;
          }
        }
      }

      .cententForChilImgBox {
        margin-top: 20px;

        .cententForChilImgBoxList {
          box-shadow: 0px 4px 20px 0px rgba(115, 115, 115, 0.3);
          border-radius: 8px;
          width: 100%;
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          // padding-bottom: 15px;
          margin-bottom: 15px;
          aspect-ratio: 26/15;

          .cententForChilImgBoxListImg {
            width: 100%;
            position: relative;
            height: 100%;

            > img {
              border-radius: 8px 8px;
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }

          .cententForChilImgBoxListDz {
            display: flex;
            width: 100%;
            padding: 0 20px;
            box-sizing: border-box;
            margin-top: 15px;

            .cententForChilImgBoxListTil {
              flex: 1;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              text-align: center;
            }

            .cententForChilImgBoxListDzImg {
              img {
                width: 20px;
                height: 20px;
              }
            }

            .cententForChilImgBoxListDzNum {
              // font-size: 14px;
              margin-left: 10px;
            }
          }
        }
      }
    }
  }
}

.top {
  padding: 16px 0;

  .nav {
    display: flex;
    font-size: 14px;
    align-items: center;
    line-height: 1;
    margin: 0 auto;

    ::v-deep {
      .el-breadcrumb {
        font-size: 14px;
      }
    }
  }
}

.swiper-canpin {
  max-width: 1200px;
  overflow: hidden;

  .swiper-slide-Two {
    width: 260px;
  }

  .swiper-slide-Two:not(:last-child) {
    margin-left: 5px;
    margin-right: 5px;
  }
}

.cententBox {
  // background-image: url('../../assets/sybj.jpg');
  background-size: 100% 100.1%;
  background-repeat: no-repeat;

  .centent {
    width: 90%;
  }
}

.dz {
  position: absolute;
  bottom: 0px;
  right: 0px;
  // height: 30px;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  justify-content: end;
  color: #fff;
  border-radius: 0 0 8px 8px;

  .dzTil {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #fff;
  }

  .dzImg {
    img {
      width: 20px;
      height: 20px;
    }
  }

  .dzNumber {
    margin-left: 10px;
  }
}

.cBox {
  display: flex;
  flex-wrap: wrap;

  .cententFor:nth-of-type(2n) {
    margin-left: 2%;
  }

  .cententFor {
    width: 49%;
  }
}

.hjzpBox {
  max-width: 100%;
  box-sizing: border-box;
  margin-top: 10px;
  .hjzpBoxTil {
    font-size: 24px;
    text-align: center;
    font-weight: 500;
    font-family: "思源黑体";
    border-bottom: 1px solid rgb(153, 153, 153);
    padding-bottom: 10px;
    width: 100%;
  }

  .cententForChilImgBox {
    margin-top: 20px;

    .cententForChilImgBoxList {
      box-shadow: 0px 4px 20px 0px rgba(115, 115, 115, 0.3);
      border-radius: 8px;
      width: 100%;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      // padding-bottom: 15px;
      margin-bottom: 15px;
      height: 150px;

      .cententForChilImgBoxListImg {
        width: 100%;
        position: relative;

        > img {
          border-radius: 8px 8px;
          width: 100%;
          height: 150px;
          object-fit: cover;
        }
      }

      .cententForChilImgBoxListDz {
        display: flex;
        width: 100%;
        padding: 0 20px;
        box-sizing: border-box;
        margin-top: 15px;

        .cententForChilImgBoxListTil {
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          text-align: center;
        }

        .cententForChilImgBoxListDzImg {
          img {
            width: 20px;
            height: 20px;
          }
        }

        .cententForChilImgBoxListDzNum {
          // font-size: 14px;
          margin-left: 10px;
        }
      }
    }
  }
}

::v-deep {
  .el-empty {
    padding: 10px 0;
  }
}

.swipbox {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 30px;
  .swipitem {
    width: calc(50% - 5px);
    box-shadow: 0px 4px 20px 0px rgba(115, 115, 115, 0.3);
    background-color: #f4f4f4;
    border-radius: 8px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 15px;
    aspect-ratio: 26/17;
    > img {
      border-radius: 8px 8px;
      width: 100%;
      height: 100%;
      object-fit: cover;
      cursor: pointer;
    }
  }
  & .swipitem:nth-child(1) {
    margin-right: 10px;
  }
  & .swipitem:nth-child(3) {
    margin-bottom: unset;
    margin-right: 10px;
  }
  & .swipitem:nth-child(4) {
    margin-bottom: unset;
  }
}

::v-deep .el-carousel__arrow {
  background-color: rgba(31, 45, 61, 0.61);
  top: 44%;
}
::v-deep .el-carousel__button {
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: rgba(31, 45, 61, 0.61);
}
::v-deep .el-carousel__indicators {
  display: flex;
  .is-active {
    .el-carousel__button {
      width: 30px;
    }
  }
}

.channelBox {
  position: relative;
  .channelImg {
    width: 100%;
    display: block;
  }

  .visionBtn {
    position: absolute;
    width: 55%;
    cursor: pointer;
    height: 6%;
    top: 13%;
    left: 21%;
  }
  .moreBtn1 {
    position: absolute;
    width: 100%;
    cursor: pointer;
    height: 5%;
    width: 11%;
    top: 3%;
    left: 64%;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .moreBtn2 {
    position: absolute;
    width: 100%;
    cursor: pointer;
    height: 5%;
    width: 11%;
    top: 53%;
    left: 64%;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .visionSwip {
    position: absolute;
    width: 53.5%;
    left: 21.7%;
    top: 21.7%;
    height: 20%;
    // .cententForChilImgBox {
    //   height: 200px;
    // }

    .nocarouselData {
      width: 100%;
      aspect-ratio: 1 / 0.3; /* 设置宽高比为1:0.6 */
      display: flex;
    }

    .nocarousel {
      width: calc(50% - 5px);
      background-color: #408f67;
      border-radius: 8px;
    }
  }
  .visionItem {
    flex-shrink: 0;
    width: 40%;
    height: 100%;
    margin-right: 5%;
    background-color: #408f67;
  }
  .workmanshipBtn {
    position: absolute;
    width: 55%;
    cursor: pointer;
    height: 6%;
    top: 63%;
    left: 21%;
  }
}

::v-deep .el-carousel__container {
  height: 100%;
}

.hideBtn {
  background-color: #006b2d;
  pointer-events: none;
  cursor: unset;
}
</style>
